import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=2a105a8a&scoped=true&"
import script from "./InformationCard.vue?vue&type=script&lang=js&"
export * from "./InformationCard.vue?vue&type=script&lang=js&"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=2a105a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a105a8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VRow})
